import React from "react";

export const ReportsStatus = ({ value, paratext, colorBox }) => {
  return (
    <React.Fragment>
      <div className="reports-small-text-value">
        <div className="d-flex align-items-center">
          <div className={colorBox}></div>
          <p>{paratext}</p>
        </div>
        <div className="col-12">
          <h4>
            {value}
            <span>pax</span>
          </h4>
        </div>
      </div>
    </React.Fragment>
  );
};
